import type { BankDetailsFormData } from '@/modules/counterparty/api/bank-details-api.ts';
import type { BankCBRF } from '@/modules/common/adapters/bank-cbrf.type.ts';
import type { SourcedOption } from '@/modules/common/types/option.type.ts';

export type CounterpartyBankDetailsItem = {
  id: string;
  bank: SourcedOption<BankCBRF>;
  bankIdentificationCode: string;
  correspondentAccount: string;
  currentAccount: string;
  comment: string;
};

export type CounterpartyBankDetailsForm = {
  bankDetails: CounterpartyBankDetailsItem[];
};

export type CounterpartyBankDetailsFormData = BankDetailsFormData;

export function createEmptyBankDetailsForm(): CounterpartyBankDetailsForm {
  return {
    bankDetails: [],
  };
}
